import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { PlatformSearchState } from './platformsearch.state';
import { getters } from './platformsearch.getters';
import { mutations } from './platformsearch.mutations';
import { actions } from './platformsearch.actions';

VueXHelper.setStoreModule(Module.PLATFORMSEARCH, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new PlatformSearchState(),
  getters,
  mutations,
  actions,
};
